<filter-item-multiple [label]="'ui.filter_active_deposit.label' | translate" icon="pi pi-money-bill" [selectedValues]="selected" [options]="options" (optionSelected)="handleSelected($event)"></filter-item-multiple>
